"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Extension;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _modelUtils = require("~/utils/modelUtils");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Extension = class Extension {
    static async get(context, extensionId, ncMeta = _Noco.default.ncMeta) {
        let extension = await _NocoCache.default.get(context, `${_globals.CacheScope.EXTENSION}:${extensionId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!extension) {
            extension = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.EXTENSIONS, extensionId);
            if (extension) {
                extension = (0, _modelUtils.prepareForResponse)(extension, [
                    'kv_store',
                    'meta'
                ]);
                _NocoCache.default.set(context, `${_globals.CacheScope.EXTENSION}:${extensionId}`, extension);
            }
        }
        return extension && new Extension(extension);
    }
    static async list(context, baseId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.EXTENSION, [
            baseId
        ]);
        let { list: extensionList } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !extensionList.length) {
            extensionList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.EXTENSIONS, {
                condition: {
                    base_id: baseId
                },
                orderBy: {
                    created_at: 'asc'
                }
            });
            if (extensionList) {
                extensionList = extensionList.map((extension)=>(0, _modelUtils.prepareForResponse)(extension, [
                        'kv_store',
                        'meta'
                    ]));
                await _NocoCache.default.setList(context, _globals.CacheScope.EXTENSION, [
                    baseId
                ], extensionList);
            }
        }
        return extensionList == null ? void 0 : extensionList.sort((a, b)=>{
            var _ref, _ref1;
            return ((_ref = a == null ? void 0 : a.order) != null ? _ref : Infinity) - ((_ref1 = b == null ? void 0 : b.order) != null ? _ref1 : Infinity);
        }).map((extension)=>new Extension(extension));
    }
    static async insert(context, extension, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(extension, [
            'id',
            'base_id',
            'fk_user_id',
            'extension_id',
            'title',
            'kv_store',
            'meta',
            'order'
        ]);
        if (insertObj.order === null || insertObj.order === undefined) {
            insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.EXTENSIONS, {
                base_id: insertObj.base_id
            });
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.EXTENSIONS, (0, _modelUtils.prepareForDb)(insertObj, [
            'kv_store',
            'meta'
        ]));
        await _NocoCache.default.incrHashField('root', `${_globals.CacheScope.RESOURCE_STATS}:workspace:${context.workspace_id}`, _nocodbsdk.PlanLimitTypes.LIMIT_EXTENSION_PER_WORKSPACE, 1);
        return this.get(context, id, ncMeta).then(async (res)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.EXTENSION, [
                extension.base_id
            ], `${_globals.CacheScope.EXTENSION}:${id}`);
            return res;
        });
    }
    static async update(context, extensionId, extension, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(extension, [
            'fk_user_id',
            'extension_id',
            'title',
            'kv_store',
            'meta',
            'order'
        ]);
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.EXTENSIONS, (0, _modelUtils.prepareForDb)(updateObj, [
            'kv_store',
            'meta'
        ]), extensionId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.EXTENSION}:${extensionId}`, (0, _modelUtils.prepareForResponse)(updateObj, [
            'kv_store',
            'meta'
        ]));
        return this.get(context, extensionId, ncMeta);
    }
    static async delete(context, extensionId, ncMeta = _Noco.default.ncMeta) {
        const res = await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.EXTENSIONS, extensionId);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.EXTENSION}:${extensionId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        await _NocoCache.default.incrHashField('root', `${_globals.CacheScope.RESOURCE_STATS}:workspace:${context.workspace_id}`, _nocodbsdk.PlanLimitTypes.LIMIT_EXTENSION_PER_WORKSPACE, -1);
        return res;
    }
    static async deleteByBaseId(context, baseId, ncMeta = _Noco.default.ncMeta) {
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.EXTENSIONS, {
            base_id: baseId
        });
        // clear cache
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.EXTENSION}:${baseId}:list`, _globals.CacheDelDirection.PARENT_TO_CHILD);
    }
    constructor(extension){
        Object.assign(this, extension);
    }
};
